export const listenerRegistry = new Set();

export function track(unsub) {
  listenerRegistry.add(unsub);
  return () => {
    try { unsub(); } finally { listenerRegistry.delete(unsub); }
  };
}

export function stopAllListeners() {
  for (const unsub of Array.from(listenerRegistry)) {
    try { unsub(); } catch {}
  }
  listenerRegistry.clear();
}
